import React from 'react'

import Link from '@Pure/Link'

import { mergeDeep } from '@root/utility'

export let form =
{
	model: 'NationalBrand'.toLowerCase(),
	name: 'NationalBrand'.toLowerCase(),

	form_title: 'Enseigne nationale',

	fields:
	{
		'name':
		{
			label: 'Nom'
		},

		'addresses[name]':
		{
			type: 'text'
		},

		'addresses[line_1]':
		{
			type: 'text'
		},

		'addresses[line_2]':
		{
			type: 'text'
		},

		'addresses[postal_code]':
		{
			type: 'text'
		},

		'addresses[city]':
		{
			type: 'text'
		},

		'addresses[position]':
		{
			type: 'text',

			readOnly: true,

			valueHook: function (value, data, name)
			{
				return value && value.lat !== undefined && value.lng !== undefined
				? 'Oui (' + value.lat + ', ' + value.lng + ')'
				: '/';
			}
		}
	},

	collapses:
	[
		{
			type: 'collapse',
			title: 'Général',
			elements:
			[
				'name',
				{
					type: 'table',
					table_name: 'addresses',
					columns:
					{
						'Nom' : 'addresses[name]',
						'Adresse' : 'addresses[line_1]',
						'Complément d\'adresse' : 'addresses[line_2]',
						'Code postal': 'addresses[postal_code]',
						'Ville': 'addresses[city]',
						'Géolocalisation': 'addresses[position]'
					},
					add: true,
					add_label: 'Ajouter une adresse',
					not_duplicated: ['addresses[position]']
				}
			]
		}
	],

	repeatable:
	[
		'addresses'
	],

	create_label: 'Créer cette enseigne',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cette enseigne&nbsp;?
				</p>

				<div className="u-center">
					<div className="name-in-modal">
						{ form_data['nationalbrand[name]'] }
					</div>
				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					La nouvelle enseigne <strong> { model.name } </strong> a été créée.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/configuration/enseignes-nationales/' + model.id }>
						Voir l'enseigne nationale
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export let list =
{
	model: 'NationalBrand'.toLowerCase(),
	title: 'Enseignes nationales',
	link: '/configuration/enseignes-nationales',
	creation_link: '/configuration/enseignes-nationales/nouvelle-enseigne',
	creation_label: 'Nouvelle enseigne',
	header_map:
	{
		'Nom': 'name'
	},
	row_link_base: '/configuration/enseignes-nationales/',
	searched_prop: 'name'
}

let config = mergeDeep({ }, form);

config = mergeDeep(form, list);

export default config